import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { ENTITY_SLUG_FIELD_TYPES } from '@cli-constants/schema.js'

export function isStringLikeSlugField(field: SchemaField): boolean {
  return ENTITY_SLUG_FIELD_TYPES.has(field.type)
}
